import { FC } from 'react';
import { Box, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';

import styles from './TripDetailsTabs.module.scss';
import { useIsMobile } from '../../../../../hooks/useWindowWidth';
interface TripDetailsTabsProps {
  selectedTab: string;
  onTabChange: (event: React.MouseEvent<HTMLElement>, newTab: string | null) => void;
}

const TripDetailsTabs: FC<TripDetailsTabsProps> = ({ selectedTab, onTabChange }) => {
  const isMobile = useIsMobile();

  return (
    <Box className={styles.tabsContainer}>
      <ToggleButtonGroup
        value={selectedTab}
        exclusive
        onChange={onTabChange}
        className={styles.toggleGroup}
      >
        <ToggleButton
          value="schedule"
          className={`${selectedTab === 'schedule' && styles.selected} ${styles.toggleButton}`}
        >
          <Typography variant={isMobile ? 'h11Bold' : 'h10Bold'}>Schedule</Typography>
        </ToggleButton>
        <ToggleButton
          value="about-country"
          className={`${selectedTab === 'about-country' && styles.selected} ${styles.toggleButton}`}
        >
          <Typography variant={isMobile ? 'h11Bold' : 'h10Bold'}>About Country</Typography>
        </ToggleButton>
        <ToggleButton
          value="travel-buddies"
          className={`${selectedTab === 'travel-buddies' && styles.selected} ${styles.toggleButton}`}
        >
          <Typography variant={isMobile ? 'h11Bold' : 'h10Bold'}>Travel Buddies</Typography>
        </ToggleButton>
        <ToggleButton
          value="documents"
          className={`${selectedTab === 'documents' && styles.selected} ${styles.toggleButton}`}
        >
          <Typography variant={isMobile ? 'h11Bold' : 'h10Bold'}>Folder</Typography>
        </ToggleButton>
        <ToggleButton
          value="packing-list"
          className={`${selectedTab === 'packing-list' && styles.selected} ${styles.toggleButton}`}
        >
          <Typography variant={isMobile ? 'h11Bold' : 'h10Bold'}>Packing list</Typography>
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default TripDetailsTabs;
